import React from "react";
import "../css/Trainers.css";

const Trainers = () => {
  const team = [
    {
      name: "ALEX STONE",
      role: "Strength Architect",
      img: "https://images.pexels.com/photos/5327450/pexels-photo-5327450.jpeg",
      desc: "Specialist in advanced hypertrophy cycles, progressive overload structuring and elite-level form correction."
    },
    {
      name: "MAYA RIVERS",
      role: "Conditioning Coach",
      img: "https://images.unsplash.com/photo-1594381898411-846e7d193883",
      desc: "Develops high-intensity conditioning systems designed to sharpen speed, endurance and movement efficiency."
    },
    {
      name: "JORDAN VALE",
      role: "Performance Director",
      img: "https://images.pexels.com/photos/4058411/pexels-photo-4058411.jpeg",
      desc: "Focuses on athlete biomechanics, mobility sequencing, and optimized energy output through movement strategy."
    }
  ];

  return (
    <div className="trainers-page">

      {/* ================= HERO ================= */}
      <section className="tr-hero">
        <h1>MEET THE TEAM</h1>
        <p>Elite coaches shaping athletes season after season.</p>
      </section>


      {/* ================= TRAINERS PANEL ================= */}
      <section className="tr-container">

        {/* Vertical Names List */}
        <div className="tr-names">
          {team.map((t, i) => (
            <div key={i} className="name-tab">
              <h3>{t.name}</h3>
            </div>
          ))}
        </div>

        {/* Trainer Cards */}
        <div className="tr-cards">
          {team.map((t, i) => (
            <div key={i} className="tr-card">
              <div className="tr-image" style={{ backgroundImage: `url(${t.img})` }}></div>
              <div className="tr-info">
                <h2>{t.name}</h2>
                <h4>{t.role}</h4>
                <p>{t.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </section>

    </div>
  );
};

export default Trainers;
